



import React from 'react';
import '../Assets/Css/markline.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaRoad, FaTools, FaRegCheckCircle, FaCogs } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import aboutsecurity from '../Assets/Images/overviewmarkline.avif';

import highwayMarkingImg from '../Assets/Images/highwaymarking.avif';
import parkingStripingImg from '../Assets/Images/parkingsidemarking.avif';
import pedestrianCrossingImg from '../Assets/Images/zebracrossing.jpg';
import ctasecureimg from '../Assets/Images/overviewmarkline.avif';
import { Helmet } from 'react-helmet';

export default function ManPowerServices() {
 const testimonials = [
  {
    message: "The mark line services were precise and professionally done. Our parking lot looks organized and safe.",
    author: "Facility Manager",
  },
  {
    message: "Excellent quality road markings on our industrial site. Clear, durable, and compliant.",
    author: "Project Engineer",
  },
  {
    message: "Quick and efficient work on pedestrian crossings and directional arrows. Highly visible and long-lasting.",
    author: "Municipal Supervisor",
  },
];



 const features = [
  {
    id: 1,
    icon: <FaRoad />,
    title: "High-Quality Markings",
  },
  {
    id: 2,
    icon: <FaTools />,
    title: "Advanced Equipment",
  },
  {
    id: 3,
    icon: <FaRegCheckCircle />,
    title: "Standards Compliance",
  },
  
];

 const services = [
  {
    title: 'Highway & Road Markings',
    description: 'Application of high-quality road markings for highways and city roads ensuring safety and proper traffic flow.',
    image: highwayMarkingImg,
  },
  {
    title: 'Parking Area Striping',
    description: 'Durable markings for parking areas, including customized layouts for efficient vehicle movement and safety.',
    image: parkingStripingImg,
  },
  {
    title: 'Pedestrian Crossings & Arrows',
    description: 'Clear and precise pedestrian crossings, directional arrows, and other custom indicators for road safety.',
    image: pedestrianCrossingImg,
  },
];

  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        <title>Mark Line Services | Precision Road Marking | Samashree Enterprises</title>
        <meta
          name="description"
          content="Samashree Enterprises offers precise, durable road marking solutions for highways, roads, parking areas, and toll plazas using advanced equipment and premium materials."
        />
        <meta
          name="keywords"
          content="road marking services, highway markings, parking area striping, pedestrian crossings, directional arrows, road safety, traffic management, Samashree Enterprises"
        />
        <meta name="author" content="Samashree Enterprises Pvt. Ltd." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.samashreeenterprises.com/mark-line-services" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Mark Line Services | Samashree Enterprises" />
        <meta
          property="og:description"
          content="Durable and high-quality road marking solutions for highways, roads, and parking areas by expert professionals using advanced equipment."
        />
        <meta property="og:url" content="https://www.samashreeenterprises.com/mark-line-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.samashreeenterprises.com/images/mark-line-services-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mark Line Services | Samashree Enterprises" />
        <meta
          name="twitter:description"
          content="Professional road marking for highways, pedestrian crossings, parking lots, and more, ensuring clear and safe traffic management."
        />
        <meta name="twitter:image" content="https://www.samashreeenterprises.com/images/mark-line-services-banner.jpg" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-sectionmark">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in" >Mark Line Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">Precision road marking solutions with advanced equipment and skilled professionals</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100"> Get in Touch </a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col md={6} className="d-flex justify-content-center align-items-center">
              <img
                src={aboutsecurity}
                alt="About Security Services"
                  className="img-fluid aboutsecimg rounded shadow mb-3"
                  data-aos="zoom-in" data-aos-delay="100"
              />
            </Col>
            <Col md={6}>
  <h2 className="page-title text-center" data-aos="fade-up" > Overview </h2>
  <p data-aos="zoom-in" data-aos-delay="100">
    At <strong>Samashree Enterprises Pvt. Ltd.</strong>, we offer precise and durable Mark Line Services for highways, roads, and parking areas. Our services include the application of high-quality road markings that ensure safety, proper traffic flow, and clear guidance for drivers and pedestrians. We use advanced machinery and premium marking materials, ensuring that the lines are highly visible, weather-resistant, and compliant with national and international standards.
  </p>
  <p data-aos="zoom-in" data-aos-delay="100">
  Our experienced team handles everything from lane demarcations and pedestrian crossings to directional arrows and customized markings for toll plazas and parking areas. Whether it’s for highways, city roads, or private infrastructures, our mark line services are designed to enhance road safety and streamline traffic management. With a focus on precision and durability, we ensure that our markings remain clear and intact for a long period, even under heavy traffic conditions.
  </p>
</Col> 
          </Row>
        </Container>
      </section>

      {/* Why Choose Us Section */}
      <section>
         <h2 className="page-title text-center" data-aos="fade-up" > Why Choose Us </h2>
      <section className="why-choose-us-bgmark py-4 bg-light">
        <Container>
         
          <Row className="text-center">
            {features.map(({ id, icon, title, description }) => (
              <Col key={id} md={4} className="mb-4">
                <Card className="feature-card1 h-100 p-4 shadow-sm" data-aos="zoom-in" data-aos-delay="100">
                   <div className="icon-box mb-3">{icon}</div>
                    <h5 className="choosetitle fw-bold">{title}</h5>
                 
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      </section>
      

      {/* Services Section */}
      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up" > Our Mark Line Services </h2>
          <Row>
            {services.map((service, index) => (
              <Col md={4} sm={12} className="mb-4" key={index}>
                <Card className="h-100 border-0 hover-shadow" data-aos="zoom-in" data-aos-delay="100">
                  <Card.Img
                    variant="top"
                    src={service.image}
                    alt={service.title}
                    className="service-image"
                  />
                  <Card.Body>
                    <Card.Title style={{ color: '#008080', textAlign: 'center' }}>
                      {service.title}
                    </Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
             <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2> Need Professional Road Marking Services? </h2>
              <p className="lead">
              Contact Samashree Enterprises Pvt. Ltd. for precise, durable, and compliant road marking solutions tailored to your infrastructure needs.
              </p>
              <a href="/contact" className="btn-get"> Get in Touch </a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={ctasecureimg}
                  alt="Professional service team at work"
                  className="img-fluid  rounded shadow"
                  data-aos="zoom-in" data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up" > What Our Clients Say </h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="200">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>
                        “{testimonial.message}”
                      </p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
